module.exports = "<div><kt-flight-route data-flight=flight data-for-flight-group-index=$index></kt-flight-route></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/directives/templates/flightRouteTooltipForConcreteGroup.tmpl.html
// module id = 3704
// module chunks = 0